import axios from 'axios'
import { MessageBox, Message } from 't-tyui'
import Cookies from 'js-cookie'
import store from '@/store/store'
import { getToken } from './cookie'

const DEFAULT_DOMAIN = 'http://client.71360.com'
var domainFullUrl = ''
function changeDataType(obj) {
  let str = ''
  if (typeof obj === 'object') {
    for (const i in obj) {
      if (typeof obj[i] !== 'function' && typeof obj[i] !== 'object') {
        str += i + '=' + obj[i] + '&'
      } else if (typeof obj[i] === 'object') {
        nextStr = ''
        str += changeSonType(i, obj[i])
      }
    }
  }
  return str.replace(/&$/g, '')
}

function changeSonType(objName, objValue) {
  if (typeof objValue === 'object') {
    for (const i in objValue) {
      if (typeof objValue[i] !== 'object') {
        const value = objName + '[' + i + ']=' + objValue[i]
        nextStr += encodeURI(value) + '&'
      } else {
        changeSonType(objName + '[' + i + ']', objValue[i])
      }
    }
  }
  return nextStr
}

class Global {
  transformEmptyObject(target) {
    // 对象为空时转为字符 --
    if (Array.isArray(target)) {
      target.forEach(object => {
        for (const key in object) {
          if (object[key] === '' || object[key] === null) {
            object[key] = '--'
          }
          if (Array.isArray(object[key]) || object[key].constructor === Object) {
            this.transformEmptyObject(object[key])
          }
        }
      })
    } else if (target.constructor === Object) {
      for (const key in target) {
        if (target[key] === '' || target[key] === null) {
          target[key] = '--'
        }
      }
    }
    return target
  }

  constructor(name) {
    this.name = name
  }

  getImgUrl(id) {
    return `${process.env.VUE_APP_BASE_API
      }tcloud-fs/fs/readImage?fileId=${id}&X-Token=${getToken()}`
  }

  setCommonMenu(path, title, parent, icon) {
    var commonMenu = []
    const userId = store.state.user.staffInfo.id
    var commonMenuCookies = Cookies.get('commonMenu' + userId)

    if (commonMenuCookies) commonMenu = JSON.parse(commonMenuCookies)

    if (!commonMenu) commonMenu = []

    var queryMenu = commonMenu.filter(function (i, itemindex) {
      return (
        i.router === path &&
        i.title === title &&
        i.parent === parent &&
        i.icon === icon
      )
    })

    var index = commonMenu.indexOf(queryMenu[0])

    if (index !== -1) commonMenu.splice(index, 1)

    var menu = {
      router: path,
      title: title,
      parent: parent,
      icon: icon
    }

    commonMenu.unshift(menu)

    if (commonMenu.length >= 8) commonMenu = commonMenu.slice(0, 8)

    Cookies.set('commonMenu' + userId, commonMenu, {
      expires: 7,
      domain: process.env.NODE_ENV === 'development' ? '' : '71360.com'
    })

    return commonMenu
  }

  authenticationStatus() {
    // // 实名认证到期时间
    // authenticationExpireDate
    // // 营业执照到期时间
    // businessLicenseExpireDate

    // // 产品激活状态 -1：未购买 0：未激活 1：已激活
    // productActivationStatus
    // // 实名认证状态 0： 未认证 1：认证通过 2：即将到期 3：已到期  4：待审核
    // realNameAuthenticationStatus
    // // 营业执照到期状态 0：未到期 1：即将到期 2：已到期
    // businessLicenseStatus
    // // 完善资料认证状态 0：未通过 1：已通过
    // materialStatus
    // // 品牌官网官网是否上线 0：未上线 1：已上线
    // chineseWebsiteStatus
    const authencaticationStatus = store.state.user.authencaticationStatus
    if (authencaticationStatus.realNameAuthenticationStatus === 0) {
      const string =
        '<h4>您的账号未完成实名认证，暂不能使用该功能</h4><p>实名认证决定了账号的归属，部分功能需实名认证后才可使用</p>'
      MessageBox.confirm(string, '实名认证', {
        dangerouslyUseHTMLString: true,
        type: 'warning',
        confirmButtonText: '立即认证',
        cancelButtonText: '下次再说',
        customClass: 'authentication-container'
      }).then(() => {
        this.goAuthentication()
      })
    } else if (
      authencaticationStatus.realNameAuthenticationStatus === 2 ||
      authencaticationStatus.realNameAuthenticationStatus === 3
    ) {
      const string = `<h4>您的实名认证${authencaticationStatus.realNameAuthenticationStatus === 3 ? '已' : '将'
        }于${authencaticationStatus.authenticationExpireDate
        }到期啦,部分功能已无法正常使用，未避免对您造成影响，请尽快重新认证！</h4>`
      MessageBox.confirm(
        string,
        `${authencaticationStatus.realNameAuthenticationStatus === 3
          ? '实名认证已到期'
          : '实名认证即将到期'
        }`,
        {
          dangerouslyUseHTMLString: true,
          type: 'warning',
          confirmButtonText: '立即认证',
          cancelButtonText: '下次再说',
          customClass: 'authentication-container'
        }
      ).then(() => {
        this.goAuthentication()
      })
    } else if (
      authencaticationStatus.businessLicenseStatus === 1 ||
      authencaticationStatus.businessLicenseStatus === 2
    ) {
      const string = `<h4>您的营业执照${authencaticationStatus.businessLicenseStatus === 2 ? '已' : '将'
        }于${authencaticationStatus.businessLicenseExpireDate
        }到期啦,部分功能已无法正常使用，未避免对您造成影响，请尽快重新认证！</h4>`
      MessageBox.confirm(
        string,
        `${authencaticationStatus.businessLicenseStatus === 2
          ? '营业执照已到期'
          : '营业执照即将到期'
        }`,
        {
          dangerouslyUseHTMLString: true,
          type: 'warning',
          confirmButtonText: '马上更新',
          cancelButtonText: '下次再说',
          customClass: 'authentication-container'
        }
      ).then(() => {
        this.goAuthentication()
      })
    } else if (authencaticationStatus.materialStatus === 0) {
      const string = '<h4>您还未完善推广资料，暂不能使用该服务</h4><p>推广资料是企业基本信息，使用所有推广服务时，需用到企业的基本信息，请尽快完善</p>'
      MessageBox.confirm(string, '完善推广资料', {
        dangerouslyUseHTMLString: true,
        type: 'warning',
        confirmButtonText: '立即完善',
        cancelButtonText: '下次再说',
        customClass: 'authentication-container'
      }).then(() => {
        this.complateData()
      })
    }
  }

  goAuthentication() {
    window.location.href =
      process.env.VUE_APP_7_OPEN +
      'userCenter/authentication/fastAuthentication'
  }

  dateFormate(date) {
    let month = date.getMonth()
    let day = date.getDate()

    if (month < 9) {
      month = '0' + (month + 1)
    } else {
      month = month + 1
    }
    if (day < 10) {
      day = '0' + day
    }
    return date.getFullYear() + '-' + month + '-' + day
  }

  getApiUrl() {
    var url = DEFAULT_DOMAIN

    if (domainFullUrl != '') {
      url = domainFullUrl
    } else if (window.CefJS) {
      domainFullUrl = CefJS.getDomainUrl()
      if (domainFullUrl) url = domainFullUrl
    }

    return url
  }

  tyunPost(url, postData) {
    var postUrl = this.getApiUrl() + url

    postData = this.addTicketInfo(postData)

    var ticketInfo = {}

    if (window.CefJS) ticketInfo = JSON.parse(CefJS.getTicketInfo())

    return axios({
      url: postUrl,
      method: 'POST',
      // data: $.param(postData),
      data: changeDataType(postData),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
        // dev环境注释掉其他头部信息 不然post会变成options请求
        // 'Ticket': ticketInfo.Ticket,
        // 'Timestamp': ticketInfo.Timestamp,
        // 'Token': ticketInfo.Token,
        // 'AppVersion': ticketInfo.AppVersion,
        // 'ServerVersion': ticketInfo.ServerVersion
      }
    })
  }

  getUploadUrl() {
    return this.getApiUrl()
  }

  addTicketInfo(postData) {
    var ticketInfo = this.getTicketInfo()

    if (!postData) postData = {}

    postData.ticket = ticketInfo.Ticket

    // postData.timestamp = ticketInfo.Timestamp;

    // postData.token = ticketInfo.Token;

    return postData
  }

  getTicketInfo() {
    var ticketInfo = {}

    if (window.CefJS) ticketInfo = JSON.parse(CefJS.getTicketInfo())

    // 请在这里填写你的测试票据信息
    var devTicket = '22222222-df14-49be-a58a-63edb0b96d75'

    ticketInfo.Ticket = ticketInfo.Ticket ? ticketInfo.Ticket : devTicket

    return ticketInfo
  }

  openMessageBox(message, type = 'error', onCloseMethod = null) {
    return Message({
      message: message,
      showClose: true,
      type: type,
      onClose: onCloseMethod,
      duration: 2000
    })
  }

  openConfirmBox(message, type = 'warning', title = '提示') {
    var myMessageBtn = getButtonColor()
    return MessageBox.confirm(message, title, {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      cancelButtonClass: myMessageBtn.cancel,
      confirmButtonClass: myMessageBtn.confirm,
      type: type
    })
  }

  openAlertBox(message, type = 'info', title = '提示') {
    var myMessageBtn = getButtonColor()
    return MessageBox.alert(message, title, {
      confirmButtonText: '确定',
      confirmButtonClass: myMessageBtn.confirm,
      type: type
    })
  }

  parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string') time = time.replace(/-/gi, '/')
      if (('' + time).length === 10) time = parseInt(time) * 1000
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      if (key === 'a') { return ['一', '二', '三', '四', '五', '六', '日'][value - 1] }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  }

  // 获取本周
  getStartWeek() {
    const oneDayLong = 24 * 60 * 60 * 1000
    const now = new Date()
    const mondayTime = now.getTime() - (now.getDay() - 1) * oneDayLong
    const monday = new Date(mondayTime)
    var start = this.dateFormate(monday)
    return start
  }

  getEndWeek() {
    const oneDayLong = 24 * 60 * 60 * 1000
    const now = new Date()
    const sundayTime = now.getTime() + (7 - now.getDay()) * oneDayLong
    const sunday = new Date(sundayTime)
    var end = this.dateFormate(sunday)
    return end
  }

  /**
   *获得本月的开始日期和结束日期
   */
  getStartMonth() {
    const oneDayLong = 24 * 60 * 60 * 1000
    const now = new Date()
    const year = now.getFullYear()
    const monthStartDate = new Date(year, now.getMonth(), 1) // 当前月1号
    var start = this.dateFormate(monthStartDate)
    return start
  }

  getEndMonth() {
    const oneDayLong = 24 * 60 * 60 * 1000
    const now = new Date()
    const year = now.getFullYear()
    const monthStartDate = new Date(year, now.getMonth(), 1) // 当前月1号
    const nextMonthStartDate = new Date(year, now.getMonth() + 1, 1) // 下个月1号
    const days =
      (nextMonthStartDate.getTime() - monthStartDate.getTime()) / oneDayLong // 计算当前月份的天数
    const monthEndDate = new Date(year, now.getMonth(), days)
    var End = this.dateFormate(monthEndDate)
    return End
  }
  formatAmount(amountStr) {
    return formatAmount(amountStr)
  }
  openUrl(url) {
    var a = document.createElement('a');
    a.href = url;
    a.target = '_blank'
    a.setAttribute('rel', 'noreferrer');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  formatThousandSeparator(num) {
    if (typeof num !== 'undefined') {
      return num.toLocaleString();
    }
    return 0
  }
  downloadFile(url, name) {
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  getBaiDuApiErrorMsg(status) {
    const obj = {
      0: '检索成功',
      1: '城市列表',
      2: '位置结果未知',
      3: '导航结果未知',
      4: '非法密钥',
      5: '非法请求',
      6: '没有权限',
      7: '服务不可用',
      // 8: '超时'
    }
    return obj[status] ? obj[status] : ''
  }
  downloadBlob(data, fileName) { // 下载导出
    const blob = new Blob([data])
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      const eLink = document.createElement('a')
      eLink.download = fileName
      eLink.style.display = 'none'
      eLink.href = URL.createObjectURL(blob)
      document.body.appendChild(eLink)
      eLink.click()
      URL.revokeObjectURL(eLink.href) // 释放URL 对象
      document.body.removeChild(eLink)
    }
  }
}
export default Global

export function formatAmount(amountStr) {
  let suffix = '-'
  let prefix = '-'
  const suffixMatch = amountStr.match(/([\d.]+)(.*)/);
  if (suffixMatch && suffixMatch.length === 3) {
    // suffixMatch[1] 是数字部分，suffixMatch[2] 是数字后面的部分（后缀）
    // 新逻辑： 小数部分超过两位截取两位，不到两位不补零。
    prefix = suffixMatch[1]
    const splitArr = prefix.split('.')
    if (splitArr.length > 1 && splitArr[1].length > 2) {
      prefix = parseFloat(prefix).toFixed(2)
    }
    suffix = suffixMatch[2]
  }
  return prefix + suffix
}


/*
 * 获取最近几天日期 getDay(0);//当天日期 getDay(-7);//7天前日期 getDay(3);//3天后日期
 *
 * */
export function getDay(day) {
  const today = new Date()
  const targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
  today.setTime(targetday_milliseconds) // 注意，这行是关键代码

  const tYear = today.getFullYear()
  let tMonth = today.getMonth()
  let tDate = today.getDate()
  tMonth = doHandleMonth(tMonth + 1)
  tDate = doHandleMonth(tDate)
  return tYear + '-' + tMonth + '-' + tDate
}

function doHandleMonth(month) {
  var m = month
  if (month.toString().length === 1) {
    m = '0' + month
  }
  return m
}

/**
 * 计算2个日期相差的天数，不包含今天，如：2016-12-13到2016-12-15，相差2天
 * @param startDateString
 * @param endDateString
 * @returns
 */
export function dateDiff(startDateString, endDateString) {
  var separator = '-' // 日期分隔符
  var startDates = startDateString.split(separator)
  var endDates = endDateString.split(separator)
  var startDate = new Date(startDates[0], startDates[1] - 1, startDates[2])
  var endDate = new Date(endDates[0], endDates[1] - 1, endDates[2])
  return parseInt(Math.abs(endDate - startDate) / 1000 / 60 / 60 / 24) // 把相差的毫秒数转换为天数
}

/**
 * 字符串日期相减，不包含今天，如：2016-12-13到2016-12-15，相差2天
 * @param startDateString
 * @param endDateString
 * @returns
 */
export function dateSubtraction(startDateString, endDateString) {
  var separator = '-' // 日期分隔符
  var startDates = startDateString.split(separator)
  var endDates = endDateString.split(separator)
  var startDate = new Date(startDates[0], startDates[1] - 1, startDates[2])
  var endDate = new Date(endDates[0], endDates[1] - 1, endDates[2])
  return parseInt((endDate - startDate) / 1000 / 60 / 60 / 24) // 把相差的毫秒数转换为天数
}

/**
 * 本月、上月、下月的起始、结束日期
 * getMonth(type,months)  //type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，months为数字类型，不传或0代表本月，-1代表上月，1代表下月
 * getMonth("s",1)  //得到下月第一天的yyyy-mm-dd格式日期
 * getMonth("e",1)  //得到下月最后一天的yyyy-mm-dd格式日期
 */
export function getMonthStartAndEndDate(type, months) {
  var d = new Date()
  var year = d.getFullYear()
  var month = d.getMonth() + 1
  if (Math.abs(months) > 12) {
    months = months % 12
  }
  if (months !== 0) {
    if (month + months > 12) {
      year++
      month = (month + months) % 12
    } else if (month + months < 1) {
      year--
      month = 12 + month + months
    } else {
      month = month + months
    }
  }
  month = month < 10 ? '0' + month : month
  var date = d.getDate()
  var firstday = year + '-' + month + '-' + '01'
  var lastday = ''
  if (
    month === '01' ||
    month === '03' ||
    month === '05' ||
    month === '07' ||
    month === '08' ||
    month === '10' ||
    month === '12'
  ) {
    lastday = year + '-' + month + '-' + 31
  } else if (month === '02') {
    if (
      (year % 4 === 0 && year % 100 !== 0) ||
      (year % 100 === 0 && year % 400 === 0)
    ) {
      lastday = year + '-' + month + '-' + 29
    } else {
      lastday = year + '-' + month + '-' + 28
    }
  } else {
    lastday = year + '-' + month + '-' + 30
  }
  var day = ''
  if (type === 's') {
    day = firstday
  } else {
    day = lastday
  }
  return day
}
/* 时时间戳转为字符串 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') { return ['一', '二', '三', '四', '五', '六', '日'][value - 1] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * 防抖函数
 */
export function debounce(fnName, time) {
  let timeout = null
  return function () {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      this[fnName]()
    }, time)
  }
}

// 排序 (降序)
export function sortKey(arr, key) {
  return arr.sort((a, b) => {
    let x = a[key]
    let y = b[key]
    return ((y < x) ? -1 : (x > y) ? 1 : 0)
  })
}

export function getNowTime(temp) {
  var now = new Date(temp);
  var year = now.getFullYear(); 	//得到年份
  var month = now.getMonth() + 1; //得到月份
  var date = now.getDate(); 		//得到日期
  month = month.toString().padStart(2, "0");
  date = date.toString().padStart(2, "0");
  return `${year}-${month}-${date}`;
}